import { AuthController } from '@controllers/auth-controller';
import { CAMPAIGN_PREVIEW, PARTNER_ROLES } from '@utils/controller-utils';
import { codeSplit } from 'bernie-core';

export class CampaignPreviewController extends AuthController {
  public pageId = CAMPAIGN_PREVIEW;
  public path = '/partner/campaign-preview';
  public routeName = 'campaign-preview';
  public bundles = [];
  public pageTitle = 'controllers.campaignPreview';
  public isPartnerView = true;
  public accessRoles = [
    PARTNER_ROLES.ADVERTISER_ADMIN,
    PARTNER_ROLES.ADVERTISER_USER,
    PARTNER_ROLES.ADVERTISER_VIEWER,
    PARTNER_ROLES.ADMIN,
  ];

  public component = codeSplit(() => import('../../views/partner/campaign-preview'));
  public exact = true;
}
